import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email", "companyId", "title", "feedback"]
  static values = {
    createUrl: String,
    csrfToken: String
  }

  addMember() {
    const email = this.emailTarget.value.trim()
    if (!email) {
      this.showFeedback("Please enter an email address.", "error")
      return
    }

    const companyId = this.companyIdTarget.value
    const title = this.titleTarget.value

    const body = new URLSearchParams({
      "project_member[email]": email,
      "project_member[company_id]": companyId,
      "project_member[title]": title
    })

    this.showFeedback("Adding member...", "info")

    fetch(this.createUrlValue, {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "X-CSRF-Token": this.csrfTokenValue
      },
      body: body
    })
      .then(response => response.json())
      .then(data => {
        if (data.message) {
          this.showFeedback(data.message, "success")
          this.emailTarget.value = ""
          this.titleTarget.value = ""
        }
      })
      .catch(() => {
        this.showFeedback("Failed to add member.", "error")
      })
  }

  showFeedback(message, type) {
    const el = this.feedbackTarget
    el.textContent = message
    el.classList.remove("hidden", "bg-green-50", "text-green-700", "bg-red-50", "text-red-700", "bg-blue-50", "text-blue-700")

    if (type === "success") {
      el.classList.add("bg-green-50", "text-green-700")
    } else if (type === "error") {
      el.classList.add("bg-red-50", "text-red-700")
    } else {
      el.classList.add("bg-blue-50", "text-blue-700")
    }

    el.classList.remove("hidden")
  }
}
